import {
    BreakpointObserver,
    Breakpoints,
    BreakpointState
} from '@angular/cdk/layout';
import { CommonModule, Location } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatCard } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import {
    MatSidenav,
    MatSidenavContainer,
    MatSidenavModule
} from '@angular/material/sidenav';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GoogleAnalyticsService } from '../../shared/service/google-analytics.service';

@Component({
    selector: 'app-account',
    templateUrl: './account.component.html',
    styleUrls: ['./account.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        TranslocoModule,
        MatTabsModule,
        MatCard,
        MatSidenav,
        MatSidenavModule,
        RouterModule,
        MatSidenavContainer,
        MatIconModule,
        MatListModule,
        FlexLayoutModule,
        MatButtonModule
    ]
})
export class AccountComponent implements OnInit {
    xSmall$: Observable<boolean> = this._breakpoints
        .observe([Breakpoints.XSmall])
        .pipe(map((value: BreakpointState) => value.matches));

    constructor(
        private readonly _breakpoints: BreakpointObserver,
        private readonly _location: Location,
        private _googleAnalyticsService: GoogleAnalyticsService
    ) {}
    ngOnInit(): void {
        this._googleAnalyticsService.pageView('My Account');
    }
    goBack() {
        this._location.back();
    }
}
